import moment from 'moment';
import { Button, SecondaryButton } from '@ox/visits-ui/components/shared/FormComponents';

interface ResumeDialogProps {
  timestamp: Date;
  sectionsCompleted: number[];
  totalSections: number;
  onResume: () => void;
  onStartFresh: () => void;
}

const tasks = [
  'Loading..',
  '√ Instructions',
  '√ Property access confirmed',
  '√ Access issues',
  '√ Property Condition',
  '√ Photo Upload',
  '√ Video submission',
  '√ Valuation',
  '√ Property Details',
  '√ Market insights',
  '√ Comparable Gate',
  '√ Comparable 1/4',
  '√ Comparable 2/4',
  '√ Comparable 3/4',
  '√ Comparable 4/4',
  '√ Utilities',
  '√ Condition',
  '√ Interior Condition',
  '√ Exterior Condition',
  '√ Interior Photo Upload',
  '√ Exterior Photo Upload',
];

export function ResumeDialog({ timestamp, sectionsCompleted, onResume, onStartFresh }: ResumeDialogProps) {
  const formatTime = (date: Date) => {
    const then = moment(date);
    const hours = moment().diff(then, 'hours');
    const minutes = moment().diff(then, 'minutes');

    if (hours > 24) {
      return then.format('L [at] LST');
    }
    if (hours > 0) {
      return `${hours} hour${hours > 1 ? 's' : ''} ago`;
    }
    return `${minutes || 1} minute${minutes > 1 ? 's' : ''} ago`;
  };

  return (
    <div className="resume-dialog-overlay">
      <div className="resume-dialog">
        <h2>Draft in progress</h2>
        <p className="timestamp">
          You have a draft from <strong>{formatTime(timestamp)}</strong>
        </p>
        <div className="completion-status">
          {sectionsCompleted.map((section) => (
            <div key={section} className="status-item">
              {tasks[section]}
            </div>
          ))}
        </div>

        <div className="button-group">
          <Button onClick={onResume}>Resume Draft</Button>
          <SecondaryButton onClick={onStartFresh}>Start Fresh</SecondaryButton>
        </div>
      </div>
    </div>
  );
}